import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=75c09bb6&"
import script from "./ContactInformation.vue?vue&type=script&lang=js&"
export * from "./ContactInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c09bb6')) {
      api.createRecord('75c09bb6', component.options)
    } else {
      api.reload('75c09bb6', component.options)
    }
    module.hot.accept("./ContactInformation.vue?vue&type=template&id=75c09bb6&", function () {
      api.rerender('75c09bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/ContactInformation.vue"
export default component.exports